export const retry = async (callback: () => Promise<void>, retries = 3, baseTimeoutMillis = 1000) => {
	try {
		await callback();
	} catch (error) {
		console.error(`Failed on ${error}, retries: ${retries}`);
		if (retries === 0) {
			throw error;
		}

		await retry(callback, retries - 1, baseTimeoutMillis * 2);
	}
};
